module.exports = __webpack_public_path__ + "statics/img/mail-relieve.318738f0.png";